import React from 'react';

const PlayerMetadataContext = React.createContext();

export default PlayerMetadataContext;